/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

import store from '@/store/index';

import {
  LayerGroup, LeafletEvent, Marker, DivIcon,
  markerClusterGroup,
  marker,
} from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import IFeature from '@/interfaces/IFeature';
import { toRaw } from 'vue';
import IPosition from '@/interfaces/IPosition';

export default class TrafficPointsLayerService extends LayerService {
  protected maxSpeedToDisplay: number = 100;
  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {};

  onMouseOver = async (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): Promise<void> => {
    store.commit('setSelectedTrafficLineCode', metaData.code);
  };
  onMouseOut = async (): Promise<void> => {
    store.commit('clearSelectedTrafficLineCode');
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = store.state.trafficPoints;

    return this.generateMarkerClusterLayer(points);
  };

  protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const markerClusterGroupInstance = markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 0,
    });

    positions.features.forEach((feature: any) => {
      if (!feature.properties.center_point) return;
      const allCoordinatesArray: any = feature;
      const pointCoordinatesArray: any = feature.properties.center_point;
      const [lng, lat] = pointCoordinatesArray as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);
      // add marker if avg speed is available and path has more than 2 points
      if (feature.properties.last_status && feature.properties.last_status.avg_speed
          && feature.properties.last_status.avg_speed <= this.maxSpeedToDisplay
          ) {
            markerClusterGroupInstance.addLayer(toRaw(singleMarker));
          }
    });

    return markerClusterGroupInstance;
  };

  public createMarker = (position: IPosition, feature: IFeature): Marker => {
    const singleMarker = marker([position.lat, position.lng], {
      icon: new DivIcon({
        html: this.generateHtmlPointTemplate(feature.properties),
        iconSize: [80, 40],
        // iconAnchor: [40, 50],
        // popupAnchor: [-3, -80],
      }),
    });

    singleMarker.on('add', () => {
      const el = singleMarker.getElement();
      if (el) {
        el.setAttribute(
          'aria-label',
          `Pokaż szczegóły punktu ${feature.properties.name}`
        );
      }
    });

    singleMarker.on('click', (e) => {
      this.onClick(e, feature.properties, singleMarker);
    });
    singleMarker.on('mouseout', (e) => {
      this.onMouseOut();
    });
    singleMarker.on('mouseover', (e) => {
      this.onMouseOver(e, feature.properties, singleMarker);
    });

    return singleMarker;
  };

  getIconLastData(metaData: any) {
    const markerData = metaData.last_status;
    let avgSpeed: number = 0;
    let color: string = metaData.color || '#000000'; // Default color if not provided
    if (markerData && markerData.avg_speed) {
      avgSpeed = markerData.avg_speed;
    }

    return {
      avgSpeed,
      color,
    }
  }

  protected generateHtmlPointTemplate = (metaData: any): string => {
    const { avgSpeed, color } = this.getIconLastData(metaData);

    const template: string = `
        <div class="map-marker-svg-traffic" style="background-color: ${color}">
          <span class="map-marker-svg-traffic__value">${avgSpeed} km/h</span>
        </div>
      `;

    if (avgSpeed) {
      return template;
    }

    return '';
  }
}
